export const ALARM_ORDER = ['B', 'R', 'N', 'S', 'E'];
